<template>
    <div>

        <!-- mensajes de confirmación -->
        <mensajeSistema></mensajeSistema>

        <v-tabs v-model="tab" dark class="rounded-lg" dense background-color="primary" active-class="tab-active"
            slider-color="#ffbc00">
            <v-tab class="font-weight-black">Admisión</v-tab>
            <v-tab class="font-weight-black">Condición</v-tab>
            <v-tab class="font-weight-black">Documentos requeridos</v-tab>
            <v-tab class="font-weight-black">Documentos y fotos</v-tab>
            <v-tab class="font-weight-black">Fechas de entrevistas</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab" touchless>
            <v-tab-item>
                <Configuracion class="mt-2" :parametros="parametros" @get-admisiones="getAdmisiones"></Configuracion>
            </v-tab-item>

            <v-tab-item>
                <Condiciones class="mt-2" :parametros="parametros" @get-admisiones="getAdmisiones"></Condiciones>
            </v-tab-item>

            <v-tab-item>
                <Requeridos class="mt-2" :parametros="parametros" @get-admisiones="getAdmisiones"></Requeridos>
            </v-tab-item>


            <v-tab-item>
                <Documentos class="mt-2" :parametros="parametros" @get-admisiones="getAdmisiones"></Documentos>
            </v-tab-item>

            <v-tab-item>
                <Entrevistas class="mt-2" :parametros="parametros" @get-admisiones="getAdmisiones"></Entrevistas>
            </v-tab-item>

        </v-tabs-items>


    </div>
</template>



<script>
import axios from '../../../helpers/axios'
import { mapMutations } from 'vuex';
import Configuracion from '@/views/Admision/Configuracion/components/Configuracion.vue'
import Condiciones from '@/views/Admision/Configuracion/components/Condiciones.vue'
import Documentos from '@/views/Admision/Configuracion/components/Documentos.vue'
import Requeridos from '@/views/Admision/Configuracion/components/Requeridos.vue'
import Entrevistas from '@/views/Admision/Configuracion/components/Entrevistas.vue'


export default {
    name: 'admisionColegio',

    components: {
        Configuracion,
        Condiciones,
        Documentos,
        Requeridos,
        Entrevistas,

    },
    data: () => ({
        tab: 0,
        datoLogin: sessionStorage,
        parametros: {
            admisiones: []
        }
    }),
    mounted() {
        this.getAdmisiones();
    },
    methods: {

        ...mapMutations("mensajeSis", ["setEnviarMens"]), 
        
        async getAdmisiones() {

            try {
                let response = await axios.get(`/admision/configuracion/${this.datoLogin.id_colegio}`);
                this.parametros.admisiones = response.data
            } catch (e) {
                this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null })
            }
        },
    }
}
</script>